export function recipientDomain(email) {
  if (typeof email !== 'string') return '';
  const match = email.trim().match(/^[^\s@<>,;]+@([^\s@<>,;]+)$/);
  if (!match || /[\/:?#\[\]*\\]/.test(match[1])) return '';
  try { return new URL(`https://${match[1].replace(/\.$/, '')}`).hostname.toLowerCase(); } catch (_) { return ''; }
}

export function unauthenticatedRecipients(targets, domains) {
  const allowed = new Set((domains || []).filter(domain => domain.verified === true).map(domain => domain.domain.toLowerCase()));
  return (targets || []).map((target, index) => ({ index, email: target.email || '', domain: recipientDomain(target.email) }))
    .filter(target => !target.domain || !allowed.has(target.domain));
}
